const sizeUnits = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

export default class FormatUtils{
    static dateTimeFormatter = new Intl.DateTimeFormat('de-DE', {
        second: "2-digit",
        minute: "2-digit",
        hour: "2-digit",
        day: "2-digit",
        month: "2-digit",
        year: "numeric"
    })

    static numberFormatter = new Intl.NumberFormat('de-DE', {
        maximumFractionDigits: 2
    })

    static formatSpace(space){
        let l = 0, n = space;
        while(n >= 1024 && ++l){
            n = n/1024;
        }

        return `${this.numberFormatter.format(n)} ${l < sizeUnits.length ? sizeUnits[l] : '??'}`
    }

}
